"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const system_message_1 = require("@alfalab/core-components/system-message");
const caption_1 = require("./components/caption");
const compact_message_1 = require("./components/compact-message");
const controls_1 = require("./components/controls");
const graphic_1 = require("./components/graphic");
const subtitle_1 = require("./components/subtitle");
const title_1 = require("./components/title");
const index_module_css_1 = __importDefault(require("./index.module.css"));
const SystemMessageComponent = ({ className, dataTestId, view = 'default', compactTitle, compactButtonText, compactIconBackgroundColor, fullHeight, onClick, paddings = 0, href, Icon, children, }) => {
    if (view === 'compact') {
        return ((0, jsx_runtime_1.jsx)(compact_message_1.CompactMessage, { onClick: onClick, href: href, className: (0, classnames_1.default)(index_module_css_1.default.compact, className), dataTestId: dataTestId, buttonText: compactButtonText, text: compactTitle, Icon: Icon, compactIconBackgroundColor: compactIconBackgroundColor }));
    }
    return ((0, jsx_runtime_1.jsx)(system_message_1.SystemMessage, { padding: paddings, fullHeight: fullHeight, className: (0, classnames_1.default)(index_module_css_1.default.component, className), dataTestId: dataTestId, children: children }));
};
/**
 *  Используется для ответов на запрос со стороны пользователя или системы.
 *
 * [Макет](https://www.figma.com/design/OiFlIdSpmFYZ5zsFGWA3TD/Web-%3A%3A-Alfa-Online-Composites?node-id=139559-310650)
 *
 * ### Правила размещения `children`
 *
 * Элементы располагаются в следующем порядке:
 *
 * - `Graphic`
 * - `Title`
 * - `Subtitle`
 * - `Caption`
 * - `Controls`.
 *
 * Каждый из элементов необязателен.
 *
 * ### Компактный вид
 *
 * Для компактного вида children не используются.
 * Используй пропсы `compactTitle`, `compactButtonText` и `view` = 'compact'.
 *
 * > Пример:
 * ```
 * <SystemMessage view='compact' compactTitle='Title' compactButtonText='Button' />
 * ```
 */
exports.SystemMessage = Object.assign(SystemMessageComponent, {
    Graphic: graphic_1.Graphic,
    Controls: controls_1.Controls,
    Caption: caption_1.Caption,
    Title: title_1.Title,
    Subtitle: subtitle_1.Subtitle,
});
